import { render } from "./CreateInvoice.vue?vue&type=template&id=1f0d3686&scoped=true"
import script from "./CreateInvoice.vue?vue&type=script&lang=js"
export * from "./CreateInvoice.vue?vue&type=script&lang=js"

import "./CreateInvoice.vue?vue&type=style&index=0&id=1f0d3686&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f0d3686"]])

export default __exports__